import { ROUTE } from '../../routes';
import AsyncStorage from '@react-native-async-storage/async-storage';
import { partnerApi } from '../../configs/api';
import { RegexConfig, getAppHeader } from '../../configs/config';
import { InputStateToken } from '@voltmoney/schema';
import { IFSCSearchActionRepo } from '../../features/bankVerify/bank_search_branch/repo';
export const closeParentModal = async (action, _datastore, { navigate, goBack, setDatastore }) => {
    console.warn('**** Test Action Triggered ****', action);
    await navigate(ROUTE.MY_ACCOUNT, {
        isFromPayOutDetails: true,
    });
};
export const closeModal = async (action, _datastore, { navigate, goBack, setDatastore }) => {
    const showErrorModal = action?.payload?.showErrorModal;
    if (showErrorModal) {
        await setDatastore(ROUTE.PAYOUT_DETAILS_SCREEN, "payoutDetailsScreen", {
            showErrorModal: false,
            modalHeight: 192,
            showSuccessModal: false,
            showPennyModal: false,
            message: ""
        });
    }
    else {
        await navigate(ROUTE.MY_ACCOUNT, {
            isFromPayOutDetails: true,
        });
    }
};
export const validateBank = async (action, _datastore, { navigate, goBack, setDatastore, network }) => {
    console.warn('**** Test Action Triggered ****', action);
    await setDatastore(ROUTE.PAYOUT_DETAILS_SCREEN, "payoutDetailsScreen", {
        showErrorModal: false,
        showSuccessModal: false,
        showPennyModal: true
    });
    const panType = action?.payload?.panType;
    const panNumber = action?.payload?.panNumber;
    const gstNumber = action?.payload?.gstNumber;
    const ifscNumber = action?.payload?.ifscNumber;
    const bankAccountNumber = action?.payload?.bankAccountNumber;
    const otherPANType = action?.payload?.otherPANType;
    const user = await AsyncStorage.getItem("user_context");
    const userData = await JSON.parse(user);
    const accountId = userData?.linkedPartnerAccounts[0]?.accountId;
    const response = await network.patch(`${partnerApi.accountAttributes}${accountId}`, {
        partnerProfileDetails: {
            panType,
            panNo: panNumber,
            gstNo: gstNumber,
            bankAccountIFSCCode: ifscNumber,
            // arnNo: arnNumber,
            // detailsFor: detailsFor,
            bankAccountNumber: bankAccountNumber,
            otherPanTypeDetail: otherPANType !== undefined || otherPANType !== '' ? otherPANType : ''
        }
    }, { headers: await getAppHeader(), handleFromMF: true });
    if (response?.status === 200) {
        setTimeout(async () => {
            await setDatastore(ROUTE.PAYOUT_DETAILS_SCREEN, "payoutDetailsScreen", {
                showErrorModal: false,
                showPennyModal: false,
                modalHeight: 240,
                showSuccessModal: true,
                message: "Unlock your earnings now by completing the client's loan application"
            });
        }, 2000);
    }
    else if (response?.response?.status === 400) {
        if (response?.response?.data?.voltErrorCode === 'BAD_REQUEST_INVALID_INPUT') {
            setTimeout(async () => {
                await setDatastore(ROUTE.PAYOUT_DETAILS_SCREEN, "payoutDetailsScreen", {
                    showErrorModal: true,
                    showSuccessModal: false,
                    showPennyModal: false,
                    errorHeading: 'Invalid bank account',
                    modalHeight: 220,
                    message: response?.response?.data?.message,
                });
            }, 2000);
        }
    }
    else if (response?.response?.status === 429) {
        setTimeout(async () => {
            await setDatastore(ROUTE.PAYOUT_DETAILS_SCREEN, "payoutDetailsScreen", {
                showErrorModal: true,
                showSuccessModal: false,
                showPennyModal: false,
                errorHeading: 'Limit exhausted',
                modalHeight: 220,
                message: 'Please try again after 5 mins.',
            });
        }, 2000);
    }
    else {
        await setDatastore(ROUTE.PAYOUT_DETAILS_SCREEN, "payoutDetailsScreen", {
            showErrorModal: true,
            showSuccessModal: false,
            showPennyModal: false,
            errorHeading: 'Verification failed!',
            modalHeight: 220,
            message: 'Something Went Wrong, Please try Again.'
        });
    }
};
export const naviagteToIfscSection = async (action, _datastore, { navigate, goBack, setDatastore, navigateWithClear }) => {
    console.warn('**** Test Action Triggered ****', action);
    const { bankName, bankLabel, bankAccountNumber, ifscNumber, panNumber, panType, gstNumber } = action?.payload;
    await navigate(ROUTE.IFSC_SECTION_SCREEN, {
        bankName, bankLabel, bankAccountNumber, ifscNumber, panNumber, panType, gstNumber
    });
};
export const validatePan = async (action, _datastore, { navigate, goBack, setDatastore }) => {
    const panNumber = action?.payload?.panNumber;
    const panRegex = new RegExp(RegexConfig.PAN);
    const isPanValied = panRegex.test(panNumber);
    if (!isPanValied) {
        await setDatastore(ROUTE.PAYOUT_DETAILS_SCREEN, "payoutDetailsScreen", {
            panState: InputStateToken.ERROR,
            gstState: InputStateToken.DISABLED,
            caption: { error: 'Enter a valid PAN' },
        });
    }
    else {
        await setDatastore(ROUTE.PAYOUT_DETAILS_SCREEN, "payoutDetailsScreen", {
            panState: InputStateToken.SUCCESS,
            gstState: InputStateToken.DEFAULT,
            caption: { error: '' },
        });
    }
};
export const validateGst = async (action, _datastore, { navigate, goBack, setDatastore }) => {
    const { panNumber, gstNumber } = action?.payload;
    const gstNumberRegex = /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/;
    if (gstNumber !== undefined && gstNumber.length > 0 && gstNumber !== '') {
        if (gstNumber.includes(panNumber) && gstNumberRegex.test(gstNumber) && gstNumber.length === 15) {
            await setDatastore(ROUTE.PAYOUT_DETAILS_SCREEN, "payoutDetailsScreen", {
                gstState: InputStateToken.DEFAULT,
                caption: { error: '' },
            });
        }
        else {
            await setDatastore(ROUTE.PAYOUT_DETAILS_SCREEN, "payoutDetailsScreen", {
                gstState: InputStateToken.ERROR,
                caption: { error: 'Please enter a valid GST number' },
            });
        }
    }
    else {
        await setDatastore(ROUTE.PAYOUT_DETAILS_SCREEN, "payoutDetailsScreen", {
            gstState: InputStateToken.DEFAULT,
            caption: { error: '' },
        });
    }
};
export const validateIfsc = async (action, _datastore, { navigate, goBack, setDatastore }) => {
    const ifscNumber = action?.payload?.ifscNumber;
    const ifscRegex = /^[A-Z]{4}0[A-Z0-9]{6}$/;
    if (ifscNumber?.length > 0) {
        if (ifscRegex.test(ifscNumber)) {
            await setDatastore(ROUTE.PAYOUT_DETAILS_SCREEN, "payoutDetailsScreen", {
                ifscState: InputStateToken.SUCCESS,
                caption: { error: '' },
            });
        }
        else {
            await setDatastore(ROUTE.PAYOUT_DETAILS_SCREEN, "payoutDetailsScreen", {
                ifscState: InputStateToken.ERROR,
                caption: { error: 'Please enter a valid IFSC number' },
            });
        }
    }
    else {
        await setDatastore(ROUTE.PAYOUT_DETAILS_SCREEN, "payoutDetailsScreen", {
            ifscState: InputStateToken.DEFAULT,
            caption: { error: '' },
        });
    }
};
export const IFSCSearchAction = async (action, _datastore, { setDatastore }) => {
    const bankCode = action?.payload?.bankName;
    const branchName = action?.payload?.value;
    let searchLength = 3;
    if (branchName?.length < searchLength)
        return;
    const response = await IFSCSearchActionRepo(bankCode, branchName);
    const bankBranchArr = [];
    Object.keys(response).map((bankCode) => {
        bankBranchArr.push({ bankCode: response[bankCode] });
    });
    await setDatastore(ROUTE.PAYOUT_DETAILS_SCREEN, "payoutDetailsScreen", {
        bankData: bankBranchArr
    });
};
export const arnValidateAction = async (action, _datastore, { setDatastore }) => {
    const arnNumber = action?.payload?.arnNumber;
    await setDatastore(ROUTE.PAYOUT_DETAILS_SCREEN, "payoutDetailsScreen", {
        arnState: InputStateToken.DEFAULT
    });
};
